/**
 * Returns true when Copilot is enabled via the global nav.
 */
export default function useHasNavCopilot() {
  var _hubspot;
  return Boolean((_hubspot = window.hubspot) === null || _hubspot === void 0 || (_hubspot = _hubspot.copilot) === null || _hubspot === void 0 ? void 0 : _hubspot.showInNav);
}